import axios from "axios";
import { authAxios } from "./axios";
import { EnvType, IChangelogRecord } from "../interfaces";
import { toast } from "react-toastify";

const ENVIRONMENT_API_URL =
  "https://hcp-locator-translations-app.azurewebsites.net/api/file/environments/environments.json";

export class Api {
  static async updateEnvTranslations(
    supportedLanguages: string[],
    isoCode: string,
    envType: EnvType
  ) {
    if (envType === EnvType?.internal) {
      const data = await authAxios.post("/update/internal", {
        languages: supportedLanguages,
        environment: isoCode,
      });

      return data;
    }

    const data = await authAxios.post("/update", {
      languages: supportedLanguages,
      environment: envType,
    });

    return data;
  }

  static async getEnvs() {
    const data = await authAxios.get(ENVIRONMENT_API_URL);

    return data;
  }

  static async getEnvSupportedLanguages(url: string) {
    const data = await axios.get(`${url}/api/settings`);

    return data;
  }

  static async getEnvVersion(url: string) {
    const data = await axios.get(`${url}/api/system-version/current`);

    return data;
  }

  static async getEnvData(url: string, endpoint: string) {
    const envSettingsUrl = `${url}/api/${endpoint}`;

    const response = await fetch(envSettingsUrl);

    return response.json();
  }

  static async getHostedTools() {
    const data = await authAxios.get("/hosted-tools");

    return data;
  }

  static async getBranchPullRequests(branch: "master" | "release") {
    const data = await authAxios.get(`/board/branch-pull-requests/${branch}`);

    return data;
  }

  static async login(username: string, password: string) {
    const result = await authAxios.post("/user/authenticate", {
      login: username,
      password: password,
    });

    if (result.status === 200) {
      localStorage.setItem("bt", result.data);
      toast.success("Logged in successfully");
      return true;
    }
    toast.error("Wrong username or password");
    return false;
  }

  static async getAllChangelogVersions(envType: EnvType) {
    const data = await authAxios.get(
      `/changelog/all-versions?environment=${envType}&offset=0&limit=10`
    );

    return data;
  }

  static async getEnvironmentChangelog(envType: EnvType, version: string) {
    const data = await authAxios.get(
      `/changelog?environment=${envType}&version=${version}`
    );

    return data;
  }

  static async addVersionChangelog(
    envType: EnvType,
    {
      changelogRecords,
      version,
    }: {
      changelogRecords: IChangelogRecord[];
      version: string;
    }
  ) {
    const data = await authAxios.put("/changelog", {
      environment: envType,
      version,
      buildNumber: version,
      workItems: changelogRecords.map((changelogRecord) => ({
        ...changelogRecord,
        type: "",
      })),
    });

    return data;
  }
}
